import React from 'react';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import qs from 'query-string';
import Content from '../../../componentes/pages/content';
import ContentManager from '../../../componentes/content-manager';
import View from './view';
import ProcessoEditView from './edit';
import { capitalizeFirstLetter } from '../../../utils/string';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import { getConfiguration } from 'src/services/commonRequests';
import MatrizRiscoFarol from 'src/paginas/gestao-risco/matriz-risco/matriz-farol-itens-impactados';

@autobind
class Processo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      idFiltroSalvo: 0,
      ehFavorito: false,
      tipoFiltro: null,
    };
  }

  getFiltroFavorito = (id, ehFavorito, tipoFiltro) => {
    this.setState({
      idFiltroSalvo: id,
      ehFavorito: ehFavorito,
      tipoFiltro: tipoFiltro,
    });
  };

  componentDidMount() {
    getConfiguration('ItemConfiguracaoProcesso')((configuracaoProcesso) =>
      this.setState({ ...this.state, configuracaoProcesso })
    )();

    const id = Number(qs.parse(window.location.search).id);
    if (!id || Number.isNaN(id)) return;

    ContentManager.addContent(
      <ProcessoEditView item={{ id }} showDelete={true} />
    );
  }
  render() {
    let { resources, intl } = this.props;
    return (
      <Content
        data-testid="gerenciar-processo-page"
        titulo={capitalizeFirstLetter(resources.processos)}
        iconSettings={true}
        titleSettings={intl.formatMessage(
          {
            id: 'configuracaoProcesso',
          },
          { processo: resources.processo }
        )}
        urlSettings="/configuracoes/processo"
        endPointPermissionSettings="/itemConfiguracaoProcesso/PossuiPermissaoConfiguracao"
        iconFavorite={true}
        filtroFavorito={{
          id: this.state.idFiltroSalvo,
          ehFavorito: this.state.ehFavorito,
          tipoFiltro: this.state.tipoFiltro,
        }}
      >
        <Tabs>
          <Tab label={capitalizeFirstLetter(resources.processos)}>
            <View {...this.props} getFiltroFavorito={this.getFiltroFavorito} />
          </Tab>
          {this.state?.configuracaoProcesso?.habilitarMatrizItensImpactados && (
            <Tab
              label={intl.formatMessage(
                { id: 'labelMatrizItensImpactados' },
                { processos: resources.processos }
              )}
            >
              <MatrizRiscoFarol {...this.props} />
            </Tab>
          )}
        </Tabs>
      </Content>
    );
  }
}
function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(Processo));
